import clsx from 'clsx';
import React from 'react';
import TimeDurationIcon from '../../assets/icons/time-duration-icon.svg?react';
import DatePicker from '../DatePicker';
import TimePicker from '../TimePicker';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import moment from 'moment';

interface DueDateExtensionRequestModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const DueDateExtensionRequestModal: React.FC<
  DueDateExtensionRequestModalProps
> = ({ otherClasses, formHandler, handleClose }) => {
  const dueDateExtensionRequestModalClasses = clsx(otherClasses);

  return (
    <div
      className={dueDateExtensionRequestModalClasses}
      data-testid="due-date-extension-request-modal"
    >
      <div className="mb-6 flex w-full flex-col items-center gap-2.5 text-center lg:mb-9">
        <TimeDurationIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine capitalize">Are you sure?</h4>
        <p className="font-inter-variable text-brand-byzantine text-lg leading-5 font-normal">
          Are you sure you want to approve this due date extension? Please note
          that this is an irreversible step. This will alert the employee that
          the due date has been extended.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <h6 className="font-inter-variable text-brand-byzantine text-lg leading-5 font-bold">
          Kindly enter new due date & time.
        </h6>
        <div className="mt-2.5 grid grid-cols-1 gap-9 md:grid-cols-2">
          <DatePicker
            otherClasses={{
              container: 'w-full',
              dropdownMainContainer: 'top-auto bottom-20 sm:!p-8 !py-8 !p-3',
            }}
            label="Date*"
            name="date"
            value={formHandler?.values?.date}
            placeholder="Select Date"
            // onBlur={formHandler.handleBlur}
            onBlur={() => {
              if (formHandler?.values?.date) {
                formHandler?.setFieldTouched('date', true);
              }
            }}
            disabled={
              formHandler.isSubmitting ||
              formHandler?.values?.dateTimeUndetermined
            }
            startMonth={moment().toDate()}
            endMonth={undefined}
            onChange={(e) => formHandler?.setFieldValue('date', e, true)}
            errorMessage={
              formHandler?.touched.date && formHandler?.errors.date
                ? formHandler?.errors.date
                : ''
            }
          />
          <TimePicker
            onBlur={formHandler?.handleBlur}
            label="Time*"
            errorMessage={
              formHandler?.touched.time && formHandler?.errors.time
                ? formHandler?.errors.time
                : ''
            }
            disabled={
              formHandler?.isSubmitting ||
              formHandler?.values?.dateTimeUndetermined
            }
            value={formHandler?.values.time}
            placeholder="Select Time"
            onChange={formHandler?.handleChange}
            name="time"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-6 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            type="submit"
            size={useButtonSizeSmall()}
          >
            Extend Due Date
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DueDateExtensionRequestModal;
